export const REGION_AGGREGATED = 'regionAggregated';

export const REGION_AGGREGATED_ACTIONS_NAME = {
  searchRegionAggregated: `${REGION_AGGREGATED}/searchRegionAggregated`,
} as const;

export const REGION_AGGREGATED_MUTATIONS_NAME = {
  setRegionAggregated: `${REGION_AGGREGATED}/setRegionAggregated`,
} as const;

export const REGION_AGGREGATED_GETTERS_NAME = {
  getRegionAggregated: `${REGION_AGGREGATED}/getRegionAggregated`,
} as const;
